import _implicitStylesheets from "./userMenu.css";
import _implicitScopedStylesheets from "./userMenu.scoped.css?scoped=true";
import _wdsAvatar from "wds/avatar";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img class="menu__banner-background${0}"${"a0:src"} alt="banner-background"${2}>`;
const $fragment2 = parseFragment`<div class="menu__header${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<li role="presentation"${3}><div class="menu__item-divider${0}"${2}></div></li>`;
const $fragment4 = parseFragment`<a${"a0:href"} class="menu__item${0}"${"a0:data-active"} tabindex="-1"${"a0:data-testid"}${2}>${"t1"}</a>`;
const stc0 = {
  classMap: {
    "menu__container": true
  },
  key: 0
};
const stc1 = {
  "type": "loginNavLink"
};
const stc2 = {
  "menu__trigger": true
};
const stc3 = {
  "tabindex": "0",
  "data-role": "dropdown"
};
const stc4 = {
  classMap: {
    "menu__banner": true
  },
  key: 5
};
const stc5 = {
  "menu__banner-avatar": true
};
const stc6 = {
  classMap: {
    "menu__items": true
  },
  attrs: {
    "role": "menu",
    "aria-label": "profile-menu"
  },
  key: 11
};
const stc7 = {
  "role": "menuitem"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, ncls: api_normalize_class_name, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6} = $ctx;
  return [$cmp.showUser ? api_element("div", stc0, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc1,
    key: 1,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("button", {
    classMap: stc2,
    attrs: {
      "data-role": "trigger",
      "aria-haspopup": "true",
      "aria-expanded": $cmp.expandedMenu,
      "aria-label": "profile-menu"
    },
    key: 2,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleTriggerClick)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleTriggerKeyDown))
    }
  }, [api_custom_element("wds-avatar", _wdsAvatar, {
    props: {
      "src": $cmp.profileImage,
      "alt": "profile-avatar",
      "size": "small"
    },
    key: 3
  })])]), api_element("div", {
    className: api_normalize_class_name($cmp.menuClassName),
    attrs: stc3,
    key: 4,
    on: {
      "keydown": _m3 || ($ctx._m3 = api_bind($cmp.handleMenuKeyDown))
    }
  }, [api_element("div", stc4, [api_static_fragment($fragment1, 7, [api_static_part(0, {
    attrs: {
      "src": $cmp.backgroundImage
    }
  }, null)]), api_custom_element("wds-avatar", _wdsAvatar, {
    classMap: stc5,
    props: {
      "src": $cmp.profileImage,
      "alt": "menu-profile-avatar"
    },
    key: 8
  })]), api_static_fragment($fragment2, 10, [api_static_part(1, null, api_dynamic_text($cmp.profileName))]), api_element("ul", stc6, api_iterator($cmp.menuItems, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return [it.last ? api_static_fragment($fragment3, api_key(13, it.value.id)) : null, api_element("li", {
      attrs: stc7,
      key: api_key(14, it.value.id)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc1,
      key: 15,
      on: {
        "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleAnalytics))
      }
    }, [api_custom_element("wds-link", _wdsLink, {
      props: {
        "label": it.value.text,
        "href": it.value.link
      },
      key: 16
    }, [api_static_fragment($fragment4, 18, [api_static_part(0, {
      on: {
        "click": _m6 || ($ctx._m6 = api_bind($cmp.handleMenuItemClick))
      },
      attrs: {
        "href": it.value.link,
        "data-active": it.value.active,
        "data-testid": it.value.id
      }
    }, null), api_static_part(1, null, api_dynamic_text(it.value.text))])])])])];
  }))])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1jncign2tc1";
tmpl.legacyStylesheetToken = "undefined-_userMenu";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
